import React from 'react';
import CookieConsentPopup from './CookieConsentPopup';

const App = ({ data }) => {
  return (
    <CookieConsentPopup data={data} />
  );
}

export default App;
